<div class="bg-white rounded-xl p-4 shadow-sm border border-slate-200/60">
  <h3 class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">Screening Progress</h3>
  <div class="grid grid-cols-2 gap-2 text-center">
    <div class="bg-slate-50 p-2.5 rounded-lg border border-slate-100">
      <div class="text-lg font-bold text-slate-700">{{ unscreenedPapers }}</div>
      <div class="text-[10px] text-slate-400 font-medium">To Screen</div>
    </div>
    <div class="bg-blue-50/40 p-2.5 rounded-lg border border-blue-100/50">
      <div class="text-lg font-bold text-blue-600">{{ partiallyScreenedPapers }}</div>
      <div class="text-[10px] text-blue-500 font-medium">In Progress</div>
    </div>
    <div class="bg-emerald-50/40 p-2.5 rounded-lg border border-emerald-100/50">
      <div class="text-lg font-bold text-emerald-600">{{ includedPapers }}</div>
      <div class="text-[10px] text-emerald-500 font-medium">Your include votes</div>
    </div>
    <div class="bg-rose-50/40 p-2.5 rounded-lg border border-rose-100/50">
      <div class="text-lg font-bold text-rose-600">{{ excludedPapers }}</div>
      <div class="text-[10px] text-rose-500 font-medium">Your exclude votes</div>
    </div>
  </div>
  <div class="mt-4">
    <div class="flex justify-between text-xs font-semibold text-slate-500 mb-1">
      <span>Progress</span>
      <span>{{ screenedCount }} / {{ totalPapers }}</span>
    </div>
    <div class="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
      <div
        class="bg-blue-500 h-full rounded-full transition-all duration-500"
        [style.width.%]="progressPercentage"
      ></div>
    </div>
  </div>

  @if (isPI && researcherProgress.length > 0) {
    <div class="mt-4 pt-4 border-t border-slate-100">
      <div class="flex items-center justify-between">
        <div>
          <span class="text-xs font-semibold text-slate-500">
            <i class="bi bi-people-fill mr-1"></i> Team
          </span>
          <span class="text-xs text-slate-400 ml-2"
            >{{ teamTotalDecisions }} / {{ teamTotalRequiredDecisions }}</span
          >
        </div>
        <button
          type="button"
          (click)="showTeamModal.set(true)"
          class="text-xs font-semibold text-secondary hover:underline"
        >
          View details
        </button>
      </div>
    </div>
  }
</div>

<app-base-modal
  [open]="showTeamModal()"
  (openChange)="showTeamModal.set($event)"
  title="Team Screening Progress"
  size="md"
>
  <div class="space-y-2">
    <div
      class="flex justify-between text-xs font-semibold text-slate-500 pb-2 border-b border-slate-100"
    >
      <span>Decisions</span>
      <span>{{ teamTotalDecisions }} / {{ teamTotalRequiredDecisions }}</span>
    </div>
    <ul class="space-y-1">
      @for (member of researcherProgress; track member.userId) {
        <li
          class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50 border border-slate-100"
        >
          <span class="text-sm text-slate-700 font-medium">
            {{ member.firstName }} {{ member.lastName }}
            @if (member.role === 'PI') {
              <span
                class="ml-1.5 text-[10px] font-bold text-violet-600 bg-violet-50 border border-violet-200 px-1.5 py-0.5 rounded-full"
                >PI</span
              >
            }
          </span>
          <span class="text-sm text-slate-500 font-medium"
            >{{ member.completedCount }} / {{ member.totalCount }}</span
          >
        </li>
      }
    </ul>
  </div>
</app-base-modal>
